module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ShareNetwork', {
    staticClass: "flex white no-underline bg-theme pv2 ph3 br-pill pointer ba bw1 db b-theme",
    attrs: {
      "url": "https://getAKKO.com",
      "description": _vm.description,
      "network": _vm.networkName,
      "quote": _vm.description,
      "title": _vm.postTitle
    }
  }, [_vm._v("\n  " + _vm._s(this.title) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7290bd20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonShareNetwork.vue
// module id = 1168
// module chunks = 0